import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'

interface ProductReturnDetailsParams {
  variant_sku?: string
  parent_sku?: string
  isParent?: boolean
}

const useGetProductReturnDetails = (params: ProductReturnDetailsParams = {}) => {
  const Api = useApi()

  const initialFilters = {
    ...(params.isParent ? {parent_sku: params.parent_sku} : {variant_sku: params.variant_sku}),
    returns_type: 'customer_returns',
    sort_by: '',
  }

  const {filters,setSingleFilter,onSortingChange} = useFilters(initialFilters,{sortType:'number'})

  // Remove parent_sku from filters for variantData query
  const { parent_sku, ...variantFilters } = filters

  const {
    data: variantData,
    isFetching,
    refetch: variantRefetch,
  } = Api.useGetQuery(
    `/analytics/replenishment/zoho/returns/data`,
    {
      queryId: `product-variant-return-details-${params.variant_sku}`,
      filters: variantFilters,
      isToast: false,
    },
    {
      enabled: !!params.variant_sku, // Only fetch when variant_sku is provided
    }
  )

  // Remove variant_sku from filters for parentData query
  const { variant_sku, ...parentFilters } = filters

  const {
    data: parentData,
    isFetching: isParentFetching,
    refetch: parentRefetch,
  } = Api.useGetQuery(
    `/analytics/replenishment/zoho/returns/parent/data`,
    {
      queryId: `product-return-details-${params.parent_sku}`,
      filters: parentFilters,
      isToast: false,
    },
    {
      enabled: !!params.parent_sku && params.isParent, // Only fetch when parent_sku is provided
    }
  )

  const fetchProductVariantReturnDetails = (variantSku: string) => {
    setSingleFilter('variant_sku', variantSku)
    variantRefetch()
  }

  const fetchProductReturnDetails = (parentSku: string) => {
    setSingleFilter('parent_sku', parentSku)
    parentRefetch()
  }

  return {
    productReturnDetails: params.isParent ? parentData?.data || [] : variantData?.data || [],
    isLoading: isFetching || isParentFetching,
    filters,
    fetchProductReturnDetails,
    fetchProductVariantReturnDetails,
    parentRefetch,
    onSortingChange
  }
}

export default useGetProductReturnDetails
